import React, { useState, useEffect } from "react";
import { Toggle, Box } from "@cloudscape-design/components";

/**
 * Theme toggle component.
 *
 * Sets `data-theme="dark"` or `data-theme="light"` on <html> element.
 * Also applies Cloudscape's dark mode class `awsui-dark-mode` on <body>.
 * Persists preference in localStorage. Falls back to OS preference on first visit.
 */
export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(() => {
    // Check localStorage first
    const stored = localStorage.getItem("smartbiz-theme");
    if (stored) return stored === "dark";
    // Fall back to OS preference
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;

    if (isDark) {
      root.setAttribute("data-theme", "dark");
      body.classList.add("awsui-dark-mode");
    } else {
      root.setAttribute("data-theme", "light");
      body.classList.remove("awsui-dark-mode");
    }
    localStorage.setItem("smartbiz-theme", isDark ? "dark" : "light");
  }, [isDark]);

  return (
    <Box float="right" padding={{ top: "xs", right: "l" }}>
      <Toggle
        onChange={({ detail }) => setIsDark(detail.checked)}
        checked={isDark}
      >
        {isDark ? "🌙 Dark" : "☀️ Light"}
      </Toggle>
    </Box>
  );
}
